var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{staticClass:"block py-12",attrs:{"height":"400"}},[_c('h1',{staticClass:"display-2 pb-16"},[_vm._v(_vm._s(_vm.title))]),_c('h4',{staticClass:"display-1 font-weight-light"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }